import { Box, Tooltip } from "@mui/material";
import { LotImagesType } from "interfaces/LotImagesInterface";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import styles from "./LotOfferImages.module.css";
import { useAppDispatch } from "app/hooks";
import { setIdsToDelete, setIndexToDelete } from "features/lotOffer/lotOfferSlice";
import { useEffect } from "react";


interface LotOfferImageProps {
  index: number;
  lotOfferImage: LotImagesType;
}

export default function LotOfferImage(props: LotOfferImageProps) {
  const baseURL = process.env.REACT_APP_API_DOMAIN
  const dispatch = useAppDispatch();
  const index = props.index;
  const thisIsALocalFile = props.lotOfferImage instanceof File || typeof props.lotOfferImage === 'string';
  const url = props.lotOfferImage instanceof File ? URL.createObjectURL(props.lotOfferImage) :
    typeof props.lotOfferImage === 'string' ? props.lotOfferImage :
      baseURL + props.lotOfferImage.url;
  useEffect(() => {
    if (props.lotOfferImage instanceof File) {
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [props.lotOfferImage, url]);
  const deleteImage = (id: string) => {
    if(thisIsALocalFile) {
      dispatch(setIndexToDelete(index))
    } else {
      dispatch(setIdsToDelete(id))
    }
  }

  const id = props.lotOfferImage instanceof File ? props.lotOfferImage.name :
    typeof props.lotOfferImage === "string" ? `string-${url}` : 
    "id" in props.lotOfferImage ? props.lotOfferImage.id : `frontend-${url}`;
  return (
    <Box>
      <Box
        component="img"
        src={url}
        sx={{
          width: "100%",
          aspectRatio: "16/9",
          objectFit: "cover",
        }}
      />
      <div className={styles.imageIcons}>
        <Tooltip title="Bild löschen" placement="bottom-end">
          <DeleteOutlineOutlinedIcon
            onClick={() => { deleteImage(id) }}
          />
        </Tooltip>
      </div>
    </Box>

  );
}
